{
  "app": {
    "name": "IoT Edge",
    "description": "منصة ذكية لمراقبة وإدارة إنترنت الأشياء"
  },
  "login": {
    "title": "تسجيل الدخول",
    "email": "البريد الإلكتروني",
    "email_placeholder": "example@domain.com",
    "password": "كلمة المرور",
    "online": "متصل",
    "password_placeholder": "أدخل كلمة المرور",
    "submit": "تسجيل الدخول",
    "remember_me": "تذكرني",
    "or": "أو",
    "biometric_login": "تسجيل الدخول باستخدام {{type}}",
    "face_id": "Face ID",
    "fingerprint": "البصمة",
    "connected": "متصل",
    "version": "الإصدار",
    "biometric_failed": "فشل التحقق بالبصمة",
    "use_password": "الرجاء استخدام كلمة المرور",
    "biometric_no_credentials_title": "لم يتم حفظ بيانات الدخول",
    "biometric_no_credentials_message": "قم بتسجيل الدخول بكلمة المرور أولاً",
    "validation": "الرجاء إدخال البريد الإلكتروني وكلمة المرور",
    "invalidEmail": "الرجاء إدخال بريد إلكتروني صحيح",
    "failed": "فشل تسجيل الدخول",
    "tooManyAttempts": "محاولات كثيرة لتسجيل الدخول",
    "rateLimitMessage": "يرجى الانتظار قبل المحاولة مرة أخرى",
    "show_password": "إظهار كلمة المرور",
    "hide_password": "إخفاء كلمة المرور",
    "toggle_password_visibility": "تبديل رؤية كلمة المرور",
    "remember_me_hint": "حفظ البريد الإلكتروني للمرة القادمة",
    "submit_hint": "تسجيل الدخول إلى حسابك"
  },
  "common": {
    "loading": "جاري التحميل...",
    "error": "حدث خطأ",
    "success": "تمت العملية بنجاح",
    "cancel": "إلغاء",
    "save": "حفظ",
    "delete": "حذف",
    "edit": "تعديل",
    "add": "إضافة",
    "search": "بحث",
    "filter": "تصفية",
    "refresh": "تحديث",
    "confirm": "تأكيد",
    "yes": "نعم",
    "no": "لا",
    "ok": "موافق",
    "back": "رجوع",
    "next": "التالي",
    "submit": "إرسال",
    "logout": "تسجيل الخروج",
    "profile": "الملف الشخصي",
    "settings": "الإعدادات",
    "unknown_organization": "مؤسسة غير معروفة"
  },
  "auth": {
    "login": "تسجيل الدخول",
    "loginTitle": "تسجيل الدخول إلى حسابك",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "rememberMe": "تذكرني",
    "forgotPassword": "نسيت كلمة المرور؟",
    "loginSuccess": "تم تسجيل الدخول بنجاح",
    "loginError": "خطأ في البريد الإلكتروني أو كلمة المرور",
    "emailRequired": "البريد الإلكتروني مطلوب",
    "passwordRequired": "كلمة المرور مطلوبة"
  },
  "navigation": {
    "dashboard": "لوحة التحكم",
    "devices": "الأجهزة",
    "alarms": "التنبيهات",
    "sites": "المواقع",
    "zones": "المناطق",
    "users": "المستخدمين",
    "reports": "التقارير",
    "profile": "الملف الشخصي",
    "deviceDetail": "تفاصيل الجهاز",
    "alarmRules": "قواعد الإنذار",
    "editDevice": "تعديل الجهاز",
    "addDevice": "إضافة جهاز",
    "qrScanner": "ماسح QR",
    "reportOptions": "خيارات التقرير",
    "customTemplates": "القوالب المخصصة",
    "notificationSettings": "إعدادات الإشعارات",
    "sitesManagement": "إدارة المواقع",
    "zonesManagement": "إدارة المناطق",
    "usersManagement": "إدارة المستخدمين",
    "settings": "الإعدادات"
  },
  "dashboard": {
    "title": "لوحة التحكم",
    "welcome": "مرحباً",
    "totalDevices": "إجمالي الأجهزة",
    "activeDevices": "الأجهزة النشطة",
    "offlineDevices": "الأجهزة غير المتصلة",
    "criticalAlarms": "التنبيهات الحرجة",
    "recentActivity": "النشاط الأخير",
    "statistics": "الإحصائيات",
    "quickActions": "إجراءات سريعة",
    "keyMetrics": "المؤشرات الرئيسية",
    "recentAlarms": "التنبيهات الأخيرة",
    "critical": "حرج",
    "offline": "غير متصل",
    "online": "متصل",
    "total": "إجمالي",
    "now": "الآن",
    "minuteAgo": "منذ دقيقة",
    "minutesAgo": "منذ {{count}} د",
    "hourAgo": "منذ ساعة",
    "hoursAgo": "منذ {{count}} س",
    "dayAgo": "منذ يوم",
    "daysAgo": "منذ {{count}} يوم",
    "systemOperational": "النظام يعمل بشكل طبيعي",
    "systemAttention": "يحتاج النظام إلى اهتمام",
    "systemCritical": "النظام في حالة حرجة"
  },
  "devices": {
    "title": "الأجهزة",
    "addDevice": "إضافة جهاز",
    "editDevice": "تعديل الجهاز",
    "deleteDevice": "حذف الجهاز",
    "deviceName": "اسم الجهاز",
    "deviceId": "معرف الجهاز",
    "deviceType": "نوع الجهاز",
    "status": "الحالة",
    "location": "الموقع",
    "zone": "المنطقة",
    "lastSeen": "آخر اتصال",
    "online": "متصل",
    "offline": "غير متصل",
    "battery": "البطارية",
    "signal": "الإشارة",
    "deleteConfirm": "هل أنت متأكد من حذف هذا الجهاز؟",
    "noDevices": "لا توجد أجهزة",
    "searchDevices": "البحث عن الأجهزة",
    "filterByZone": "تصفية حسب المنطقة",
    "filterByStatus": "تصفية حسب الحالة",
    "all": "الكل",
    "organization": "المنظمة",
    "role": "الصلاحية",
    "user": "المستخدم",
    "scanQRCode": "مسح رمز QR",
    "scannedSuccessfully": "تم المسح بنجاح",
    "formFilledFromQR": "تم ملء البيانات من رمز QR",
    "deviceAdded": "تم إضافة الجهاز بنجاح",
    "mqttCredentials": "بيانات MQTT",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "enterDeviceName": "الرجاء إدخال اسم الجهاز",
    "selectSiteAndZone": "الرجاء اختيار الموقع والمنطقة",
    "savingDevice": "جاري حفظ الجهاز...",
    "changesSaved": "تم حفظ التغييرات بنجاح",
    "failedToSave": "فشل حفظ الجهاز",
    "failedToLoad": "فشل تحميل بيانات الجهاز",
    "hasBattery": "يحتوي على بطارية",
    "alarmRulesTemplate": "قالب قواعد التنبيهات",
    "selectTemplate": "اختر قالب قواعد التنبيهات",
    "noTemplate": "لا يوجد (يمكن الإضافة لاحقاً)",
    "templateApplied": "تم تطبيق قالب التنبيهات",
    "rulesCount": "قاعدة",
    "canAddLater": "يمكن إضافة قواعد التنبيهات لاحقاً",
    "deviceTypes": {
      "SENSOR": "حساس عام",
      "TEMPERATURE": "حساس حرارة",
      "HUMIDITY": "حساس رطوبة",
      "TEMP_HUMIDITY": "حرارة ورطوبة",
      "LEVEL": "حساس مستوى",
      "ENERGY": "عداد طاقة",
      "POWER": "عداد قدرة",
      "WATER": "عداد ماء",
      "GAS": "عداد غاز",
      "MOTION": "حساس حركة",
      "DOOR": "حساس باب",
      "CAMERA": "كاميرا",
      "ACTUATOR": "مشغل",
      "MULTI_SENSOR": "حساس متعدد"
    }
  },
  "alarms": {
    "title": "التنبيهات",
    "noAlarms": "لا توجد تنبيهات",
    "critical": "حرج",
    "warning": "تحذير",
    "info": "معلومات",
    "acknowledged": "تم الاطلاع",
    "unacknowledged": "لم يتم الاطلاع",
    "acknowledge": "وضع علامة كمقروء",
    "alarmType": "نوع التنبيه",
    "device": "الجهاز",
    "timestamp": "الوقت",
    "message": "الرسالة",
    "priority": "الأولوية",
    "filterBySeverity": "تصفية حسب الأهمية",
    "filterByStatus": "تصفية حسب الحالة"
  },
  "customTemplates": {
    "title": "قوالب التنبيهات المخصصة",
    "subtitle": "قوالب التنبيهات الخاصة بمنظمتك",
    "create": "إنشاء قالب جديد",
    "edit": "تعديل القالب",
    "delete": "حذف القالب",
    "save": "حفظ القالب",
    "noTemplates": "لا توجد قوالب مخصصة",
    "emptyMessage": "انقر على + لإنشاء قالب تنبيهات مخصص",
    "nameEnglish": "الاسم (إنجليزي)",
    "nameArabic": "الاسم (عربي)",
    "descriptionEnglish": "الوصف (إنجليزي)",
    "descriptionArabic": "الوصف (عربي)",
    "category": "التصنيف",
    "pharmaceutical": "صيدلانية",
    "medical": "طبية",
    "laboratory": "مختبرية",
    "active": "نشط",
    "rules": "القواعد",
    "addRule": "إضافة قاعدة",
    "rule": "قاعدة",
    "type": "النوع",
    "temperature": "حرارة",
    "humidity": "رطوبة",
    "battery": "بطارية",
    "severity": "الخطورة",
    "critical": "حرج",
    "warning": "تحذير",
    "info": "معلومة",
    "lowThreshold": "الحد الأدنى",
    "highThreshold": "الحد الأعلى",
    "hysteresis": "التذبذب",
    "debounce": "التأخير (ث)",
    "cooldown": "فترة التهدئة (ث)",
    "noRules": "لا توجد قواعد. انقر \"إضافة قاعدة\" للبدء",
    "confirmDelete": "تأكيد الحذف",
    "deleteMessage": "هل أنت متأكد من حذف القالب \"{{name}}\"؟",
    "saveSuccess": "تم حفظ القالب بنجاح",
    "saveFailed": "فشل حفظ القالب",
    "deleteSuccess": "تم حذف القالب",
    "deleteFailed": "فشل حذف القالب",
    "loadFailed": "فشل تحميل القوالب المخصصة",
    "nameRequired": "الرجاء إدخال اسم القالب بالعربية والإنجليزية",
    "rulesRequired": "الرجاء إضافة قاعدة واحدة على الأقل",
    "rulesCount": "{{count}} قاعدة"
  },
  "sites": {
    "title": "المواقع",
    "addSite": "إضافة موقع",
    "editSite": "تعديل الموقع",
    "deleteSite": "حذف الموقع",
    "siteName": "اسم الموقع",
    "address": "العنوان",
    "description": "الوصف",
    "zonesCount": "عدد المناطق",
    "devicesCount": "عدد الأجهزة",
    "noSites": "لا توجد مواقع",
    "deleteConfirm": "هل أنت متأكد من حذف هذا الموقع؟"
  },
  "zones": {
    "title": "المناطق",
    "addZone": "إضافة منطقة",
    "editZone": "تعديل المنطقة",
    "deleteZone": "حذف المنطقة",
    "zoneName": "اسم المنطقة",
    "site": "الموقع",
    "description": "الوصف",
    "devicesCount": "عدد الأجهزة",
    "noZones": "لا توجد مناطق",
    "deleteConfirm": "هل أنت متأكد من حذف هذه المنطقة؟",
    "selectSite": "اختر الموقع",
    "medicalProfile": "الملف التعريفي الطبي",
    "selectProfile": "اختر الملف التعريفي",
    "temperatureRange": "نطاق درجة الحرارة",
    "humidityRange": "نطاق الرطوبة",
    "pressureRange": "نطاق الضغط"
  },
  "pressure": {
    "differentialPressure": "الضغط التفاضلي",
    "pressureUnit": "Pa",
    "positivePressure": "ضغط إيجابي",
    "negativePressure": "ضغط سلبي",
    "normalPressure": "طبيعي",
    "highPressure": "ضغط مرتفع",
    "lowPressure": "ضغط منخفض"
  },
  "medicalProfiles": {
    "title": "الملفات التعريفية الطبية",
    "refrigeratorMeds": "ثلاجة أدوية - حفظ عام (2-8°C)",
    "refrigeratorVaccines": "ثلاجة لقاحات - سلسلة باردة (2-8°C)",
    "freezerVaccines": "مجمد لقاحات (-25 إلى -15°C)",
    "deepFreezer": "مجمد عميق للعينات (-80 إلى -60°C)",
    "bloodBank": "بنك الدم (1-6°C)",
    "frozenPlasma": "بلازما مجمدة (-30 إلى -20°C)",
    "pharmacyStorage": "صيدلية - تخزين عام (15-25°C)",
    "medsWarehouse": "مستودع أدوية (15-25°C)",
    "controlledMeds": "غرفة أدوية خاضعة للرقابة (15-25°C)",
    "operatingRoom": "غرفة عمليات (20-24°C)",
    "icu": "عناية مركزة (20-24°C)",
    "patientRoom": "غرفة مرضى عادية (20-24°C)",
    "isolationRoom": "غرفة عزل (20-24°C)",
    "neonatalIncubator": "حضانة أطفال حديثي الولادة (24-26°C)",
    "clinicalLab": "مختبر تحاليل طبية (18-25°C)",
    "pathologyLab": "مختبر علم الأمراض (18-24°C)",
    "medicalEquipment": "غرفة أجهزة طبية حساسة (18-24°C)",
    "biochemistryLab": "مختبر كيمياء حيوية (20-25°C)",
    "mriRoom": "غرفة أجهزة التصوير بالرنين المغناطيسي (18-22°C)",
    "serverRoom": "غرفة خوادم نظام المعلومات (18-24°C)",
    "sterilizationRoom": "غرفة تعقيم مركزية (18-22°C)"
  },
  "users": {
    "title": "إدارة المستخدمين",
    "addUser": "إضافة مستخدم",
    "editUser": "تعديل المستخدم",
    "deleteUser": "حذف المستخدم",
    "userName": "اسم المستخدم",
    "email": "البريد الإلكتروني",
    "role": "الدور",
    "permissions": "الصلاحيات",
    "status": "الحالة",
    "active": "نشط",
    "inactive": "غير نشط",
    "noUsers": "لا يوجد مستخدمين",
    "deleteConfirm": "هل أنت متأكد من حذف هذا المستخدم؟",
    "admin": "مدير",
    "operator": "مشغل",
    "viewer": "عارض",
    "roles": {
      "systemAdmin": "مدير النظام",
      "facilityManager": "مدير المنشأة الصحية",
      "departmentSupervisor": "مشرف القسم",
      "technician": "فني طبي",
      "qualityManager": "مدير الجودة والسلامة",
      "infectionControl": "مسؤول مكافحة العدوى",
      "medicalMaintenance": "مسؤول الصيانة الطبية",
      "pharmacist": "صيدلي",
      "patientSafety": "أخصائي سلامة المرضى",
      "monitor": "مراقب",
      "qualityAuditor": "مدقق جودة",
      "platformAdmin": "مدير المنصة"
    }
  },
  "profile": {
    "title": "الملف الشخصي",
    "personalInfo": "المعلومات الشخصية",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "changePassword": "تغيير كلمة المرور",
    "currentPassword": "كلمة المرور الحالية",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور",
    "updateProfile": "تحديث الملف الشخصي",
    "passwordChanged": "تم تغيير كلمة المرور بنجاح"
  },
  "settings": {
    "title": "الإعدادات",
    "general": "عام",
    "language": "اللغة",
    "theme": "المظهر",
    "light": "فاتح",
    "dark": "داكن",
    "system": "النظام",
    "notifications": "الإشعارات",
    "pushNotifications": "إشعارات الدفع",
    "emailNotifications": "إشعارات البريد الإلكتروني",
    "alarmNotifications": "إشعارات التنبيهات",
    "account": "الحساب",
    "about": "حول التطبيق",
    "version": "الإصدار",
    "privacy": "الخصوصية",
    "terms": "الشروط والأحكام",
    "support": "الدعم الفني"
  },
  "reports": {
    "title": "التقارير",
    "generate": "إنشاء تقرير",
    "dateRange": "الفترة الزمنية",
    "from": "من",
    "to": "إلى",
    "deviceReport": "تقرير الأجهزة",
    "alarmReport": "تقرير التنبيهات",
    "userReport": "تقرير المستخدمين",
    "export": "تصدير",
    "pdf": "PDF",
    "excel": "Excel"
  },
  "sensor_provisioning": {
    "scan_barcode": "مسح باركود المجس",
    "detection_result": "نتيجة الكشف",
    "unmapped_sensors": "المجسات غير المربوطة",
    "device_config": "إعداد الجهاز",
    "success_title": "تم إنشاء الجهاز بنجاح!",
    "scan_instruction": "قم بمسح باركود المجس (20 رقماً)",
    "scan_button": "مسح باركود",
    "or_view_list": "أو عرض قائمة المجسات غير المربوطة",
    "scanning": "جاري المسح...",
    "invalid_serial": "رقم تسلسلي غير صالح",
    "serial_must_be_20": "يجب أن يكون الرقم التسلسلي 20 رقماً بالضبط",
    "detection_error": "خطأ في الكشف",
    "detected_sensor": "تم كشف المجس",
    "gateway_info": "معلومات البوابة",
    "sensor_info": "معلومات المجس",
    "sensor_number": "رقم المجس",
    "sensor_type": "نوع المجس",
    "manufacturer": "الشركة المصنعة",
    "protocol": "البروتوكول",
    "next_configure": "التالي: الإعداد",
    "no_unmapped_sensors": "لا توجد مجسات غير مربوطة",
    "add_sensor_via_scan": "أضف مجساً جديداً عن طريق المسح",
    "refresh_list": "تحديث القائمة",
    "loading_sensors": "جاري تحميل المجسات...",
    "serial_number": "الرقم التسلسلي",
    "last_seen": "آخر ظهور",
    "configure_sensor": "إعداد المجس",
    "device_information": "معلومات الجهاز",
    "device_name": "اسم الجهاز",
    "device_name_placeholder": "مثال: مجس حرارة المستودع A",
    "select_zone": "اختر المنطقة",
    "zone_optional": "اختياري",
    "alarm_rules": "قواعد الإنذار",
    "high_threshold": "حد الإنذار العلوي",
    "low_threshold": "حد الإنذار السفلي",
    "hysteresis": "هيستيريسيس (Hysteresis)",
    "debounce_seconds": "تأخير التأكيد (ثواني)",
    "cooldown_minutes": "مدة التهدئة (دقائق)",
    "severity": "مستوى الخطورة",
    "enable_notifications": "تفعيل الإشعارات",
    "severity_low": "منخفض",
    "severity_medium": "متوسط",
    "severity_high": "عالٍ",
    "severity_critical": "حرج",
    "alarm_rules_explanation": "قواعد الإنذار تتحكم في متى يتم إصدار تنبيه",
    "hysteresis_explanation": "فرق درجة الحرارة للعودة للوضع الطبيعي",
    "debounce_explanation": "المدة الزمنية قبل تأكيد الإنذار",
    "cooldown_explanation": "الوقت بين الإنذارات المتتالية",
    "configuration_summary": "ملخص الإعداد",
    "save_and_provision": "حفظ وتفعيل الجهاز",
    "provisioning": "جاري التفعيل...",
    "validation_device_name": "اسم الجهاز مطلوب",
    "validation_zone": "يجب اختيار منطقة",
    "validation_high_threshold": "حد الإنذار العلوي مطلوب",
    "validation_low_threshold": "حد الإنذار السفلي مطلوب",
    "validation_thresholds_invalid": "الحد العلوي يجب أن يكون أكبر من الحد السفلي",
    "provisioning_failed": "فشل تفعيل الجهاز",
    "mqtt_credentials": "بيانات اتصال MQTT",
    "mqtt_broker": "خادم MQTT",
    "mqtt_port": "المنفذ",
    "mqtt_username": "اسم المستخدم",
    "mqtt_password": "كلمة المرور",
    "mqtt_client_id": "معرّف العميل",
    "show_password": "إظهار كلمة المرور",
    "hide_password": "إخفاء كلمة المرور",
    "copy_password": "نسخ كلمة المرور",
    "password_copied": "تم نسخ كلمة المرور",
    "setup_instructions": "تعليمات الإعداد",
    "instruction_1": "1. افتح واجهة WES X280 Gateway",
    "instruction_2": "2. اذهب إلى: Point Management → Northbound Channel",
    "instruction_3": "3. أنشئ قناة MQTT جديدة وأدخل البيانات أعلاه",
    "instruction_4": "4. اربط datapoints بالقناة وفعّل الإرسال",
    "next_steps": "الخطوات التالية",
    "view_device_dashboard": "عرض لوحة تحكم الجهاز",
    "back_to_dashboard": "العودة للوحة التحكم الرئيسية",
    "connection_details": "تفاصيل الاتصال",
    "sensor_temperature": "حرارة",
    "sensor_humidity": "رطوبة",
    "sensor_pressure": "ضغط",
    "sensor_co2": "ثاني أكسيد الكربون",
    "unit_celsius": "درجة مئوية",
    "unit_fahrenheit": "فهرنهايت",
    "unit_percent": "نسبة مئوية",
    "unit_ppm": "جزء في المليون"
  },
  "errors": {
    "networkError": "خطأ في الاتصال بالشبكة",
    "serverError": "خطأ في الخادم",
    "unauthorized": "غير مصرح",
    "forbidden": "ممنوع",
    "notFound": "غير موجود",
    "validationError": "خطأ في التحقق من البيانات",
    "unknownError": "خطأ غير معروف"
  }
}
